import type { Exercice, Mouvement } from '@mairistem/comptabilite';
import { isNil } from 'lodash';
import TYPE_COMPTA from '../../constants/common/typeCompta';

interface RenderMontantProps {
	mouvement: Mouvement;
	exercice: Partial<Exercice>;
}

interface RenderMontantResult {
	mtHt: { value: number | null; comptabilise: boolean };
	mtTtc: { value: number; comptabilise: boolean };
	montantComptabilise?: number;
	showPicto: boolean;
}

const renderMontant = ({
	mouvement,
	exercice,
}: RenderMontantProps): RenderMontantResult => {
	const { montantHt, montantTtc, identifiantCodeServiceTva } = mouvement;
	const { typeCompta } = exercice;
	const gestionTva = !!exercice.gestionTva;

	// Cas simple : pas de TVA (HT === TTC)
	if (montantHt === montantTtc) {
		return {
			mtHt: { value: null, comptabilise: false },
			mtTtc: { value: montantTtc, comptabilise: true },
			montantComptabilise: montantTtc,
			showPicto: false,
		};
	}

	// Détermine si on comptabilise en HT
	const hasServiceTva = !isNil(identifiantCodeServiceTva);
	const comptaHT =
		(typeCompta === TYPE_COMPTA.HT && gestionTva) ||
		(typeCompta === TYPE_COMPTA.TTC && !gestionTva && hasServiceTva);

	if (comptaHT) {
		return {
			mtHt: { value: montantHt, comptabilise: true },
			mtTtc: { value: montantTtc, comptabilise: false },
			montantComptabilise: montantHt,
			showPicto: true,
		};
	}

	// Par défaut : comptabilisation en TTC
	return {
		mtHt: { value: montantHt, comptabilise: false },
		mtTtc: { value: montantTtc, comptabilise: true },
		montantComptabilise: montantTtc,
		showPicto: true,
	};
};

export default renderMontant;
